import { render, staticRenderFns } from "./SynchrotronReviewDashboard.vue?vue&type=template&id=acff950e&scoped=true&"
import script from "./SynchrotronReviewDashboard.vue?vue&type=script&lang=js&"
export * from "./SynchrotronReviewDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acff950e",
  null
  
)

export default component.exports